export default {"src":"/pro/_next/static/media/dydx.97e5e785.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};